/**
 * イベントタイトルABテスト用のComposable
 */

import { getEventTitleWithABTest, sendListViewABTestGA, sendDetailViewABTestGA, sendTicketClickABTestGA } from '@/utils/abtest/eventTitleABTestUtils'

export default function useEventTitleABTest() {
  /**
   * ABテスト対応のイベントタイトルを取得
   * @param {Object} event - イベントオブジェクト
   * @returns {string} - 表示するタイトル
   */
  const getTitle = event => {
    try {
      return getEventTitleWithABTest(event)
    } catch (error) {
      console.error('A/B test composable error:', error)
      return event?.title || ''
    }
  }

  /**
   * イベント一覧でのビューイベント送信
   * @param {Object} event - イベントオブジェクト
   */
  const trackListView = event => {
    try {
      sendListViewABTestGA(event)
    } catch (error) {
      console.error('List view tracking error:', error)
    }
  }

  /**
   * イベント詳細でのビューイベント送信
   * @param {Object} event - イベントオブジェクト
   * @param {boolean} fromList - 一覧経由かどうか
   */
  const trackDetailView = (event, fromList = false) => {
    try {
      sendDetailViewABTestGA(event, fromList)
    } catch (error) {
      console.error('Detail view tracking error:', error)
    }
  }

  /**
   * チケット選択時のイベント送信
   * @param {number} eventId - イベントID
   */
  const trackTicketClick = eventId => {
    try {
      sendTicketClickABTestGA(eventId)
    } catch (error) {
      console.error('Ticket click tracking error:', error)
    }
  }

  return {
    getTitle,
    trackListView,
    trackDetailView,
    trackTicketClick
  }
}
